import { createDspFxNode } from './dspModule';
import { dspAssetUrl } from './dspAssetUrl';

const WORKLET_URL = dspAssetUrl('/audio/la2aProcessor.js');
const workletLoads = new WeakMap();

export function createLa2aNode(context, params = {}) {
  return createDspFxNode(context, {
    workletUrl: WORKLET_URL, processorName: 'cookup-la2a', params, workletLoads
  });
}

export const sendLa2aParams = (node, params) => {
  node?.port?.postMessage({ type: 'params', params });
};
